import script from "./AdminSelectionPrestation.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSelectionPrestation.vue?vue&type=script&setup=true&lang=js"

import "./AdminSelectionPrestation.vue?vue&type=style&index=0&id=306014d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306014d4"]])

export default __exports__